import { InstructorTableRowType } from '@/enums/InstructorTableRowType';
import { InstructorTableCellType } from '@/enums/InstructorTableCellType';
import store from '@/store';
export default class InstructorTableInstructorRow {
    rowType = InstructorTableRowType.INSTRUCTOR;
    instructorId;
    addedDate;
    cells = [];
    table;
    constructor(table) {
        this.table = table;
    }
    isCurrentUserRow() {
        return store.getters['user/userId'] === this.instructorId;
    }
    toSaveObject() {
        const { table, ...rest } = this;
        const saveObject = {
            ...rest,
            addedDate: this.addedDate.format('YYYY-MM-DD HH:mm:ss'),
            cells: this.cells.filter(x => x.cellType !== InstructorTableCellType.PAUSE).map(x => x.toSaveObject())
        };
        return saveObject;
    }
}
